import { makeSubmitData } from "api/makeApiRequestType/makeSubmitData";

export const cancelMeeting = makeSubmitData<{ id: string; message?: string }>(
	"meetingCancel"
);
